import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from 'src/app/core/constants/api-endpoints.constant';
import { environment } from 'src/environments/environment';

import { ConfigMail } from './config-mail.interface';
import { MailType } from './mails-modal.component';
import { ServerResponse } from 'src/app/core/interfaces/server.interface';

const baseUrl = environment.baseUrl;

@Injectable({
    providedIn: 'root'
})
export class ConfigMailsService {

    private http = inject(HttpClient);

    getMails(): Observable<{ data: ConfigMail[] }> {
        return this.http.get<{ data: ConfigMail[] }>(`${baseUrl}${API_ENDPOINTS.MAILS}`);
    }

    saveMails(type: MailType, mails: string[]): Observable<ServerResponse> {
        return this.http.post<ServerResponse>(`${baseUrl}${API_ENDPOINTS.MAILS}`, { "type": type, "emails": mails });
    }



















}
